module.exports = __webpack_public_path__ + "img/external-drive.1a63faf3.svg";